module.exports = __webpack_public_path__ + "static/media/contactsGreen.8a798714.svg";